import { render, staticRenderFns } from "./dealDialog.vue?vue&type=template&id=30a20cac"
import script from "./dealDialog.vue?vue&type=script&lang=ts"
export * from "./dealDialog.vue?vue&type=script&lang=ts"
import style0 from "./dealDialog.vue?vue&type=style&index=0&id=30a20cac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports